let prefixer: string | undefined;

const hostname = window.location.hostname;
const port = window.location.port;

switch (hostname) {
  case process.env.REACT_APP_STAGING_HOST:
  case process.env.REACT_APP_PARTNER_STAGING_HOST:
    prefixer = process.env.REACT_APP_STAGING_API_URL;
    break;
  case process.env.REACT_APP_DEV_HOST:
  case process.env.REACT_APP_PARTNER_DEV_HOST:
    prefixer = process.env.REACT_APP_DEV_API_URL;
    break;
  case process.env.REACT_APP_PROD_HOST:
  case process.env.REACT_APP_PARTNER_PROD_HOST:
    prefixer = process.env.REACT_APP_PROD_API_URL;
    break;
  default:
    if (port === process.env.REACT_APP_PORT)
      prefixer = process.env.REACT_APP_LOCAL_API_URL;
    else if (hostname.includes('release'))
      prefixer = process.env.REACT_APP_STAGING_API_URL;
    else prefixer = process.env.REACT_APP_DEV_API_URL;
}

export interface GlobalPaginate {
  page?: number;
  per_page?: number;
}

export interface GlobalSearch {
  keyword?: string;
}

export interface GlobalFilter {
  filter?: Record<string, string[]>;
}

export interface GlobalExport {
  selectedIds?: number[];
}

export const AuthUrls = {
  PASSWORD_LOGIN: `${prefixer}/auth/login`,
  RESET_PASSWORD_INIT: `${prefixer}/auth/forgot-password`,
  RESET_PASSWORD: `${prefixer}/auth/reset-password`,
  CREATE_PASSWORD: `${prefixer}/auth/create-password`,
  CREATE_PASSWORD_TOKEN_STATUS: `${prefixer}/auth/activation-token/status`,
  REFRESH_TOKEN: `${prefixer}/auth/refresh-token`,
};

export const UserUrls = {
  GET_CONNECTED_INFO: `${prefixer}/user/me`,
  PASSWORD_CHANGE: `${prefixer}/user/update/password`,
  GET_ACCOUNT_INFO: `${prefixer}/user/infos`,
  CHANGE_AVATAR: `${prefixer}/user/update/avatar`,
  RESEND_FIRST_EMAIL: `${prefixer}/user/resend-first-email`,
  GET_ACCOUNT_SF_OWNER_INFO: `${prefixer}/user/me/sf-owner`,
  ADD_DEVICE: `${prefixer}/user/device`,
  REMOVE_DEVICE: (token: string) => `${prefixer}/user/device/${token}`,
};

export const TransactionUrls = {
  LIST: (page: number, per_page: number) =>
    `${prefixer}/transactions?page=${page}&per_page=${per_page}`,
  DETAILS: (id: string) => `${prefixer}/transactions/${id}`,
  INTERLOCUTORS: (id: string) => `${prefixer}/transactions/${id}/interlocutors`,
  UPLOAD: (id: string | number, category: string) =>
    `${prefixer}/transactions/${id}/${category}/upload`,
  LIST_DOCUMENTS: (id: number | string) =>
    `${prefixer}/transactions/${id}/documents`,
  DOWNLOAD_DOCUMENT: (id: string | number) =>
    `${prefixer}/transactions/documents/${id}/download`,
  SELECT_SCENARIO: (id: string | number) =>
    `${prefixer}/transactions/${id}/select-scenario`,
  PARTNER_TRANSACTIONS: ({
    filter,
    ...options
  }: GlobalPaginate & GlobalSearch & GlobalFilter) => {
    return `${prefixer}/transactions/partner/list?${new URLSearchParams({ ...filter, ...options } as Record<string, string>).toString()}`;
  },
  PARTNER_TRANSACTIONS_DOWNLOAD: ({
    filter,
    ...options
  }: GlobalExport & GlobalSearch & GlobalFilter) => {
    return `${prefixer}/transactions/partner/download?${new URLSearchParams({ ...filter, ...options } as Record<string, string>).toString()}`;
  },
};

export const MeetingUrls = {
  LIST_MEETING_LINKS: (hubspotUserId: number | string) =>
    `${prefixer}/meetings/${hubspotUserId}/meeting-links`,
  CANCEL_CURRENT_MEETING: () =>
    `${prefixer}/meetings/logged-user/meeting/cancel`,
  GET_CURRENT_MEETING: () => `${prefixer}/meetings/logged-user/meeting`,
};

export const NotificationsUrls = {
  ALL: `${prefixer}/notifications`,
  UNREAD: `${prefixer}/notifications?unreadOnly=true`,
  MARK_AS_READ: (notificationId: string) =>
    `${prefixer}/notifications/${notificationId}/read`,
};

export const RessourcesUrls = {
  LIST: () => `${prefixer}/ressources`,
};

export const TravauxUrls = {
  UPLOAD_DEVIS: `${prefixer}/travaux/upload-devis`,
};
